<template>
  <PaginationRoot
    :page="props.modelValue"
    @update:page="
      (idx: number) => {
        $emit('update:modelValue', idx);
        $emit('change', idx);
      }
    "
    :total="calculatedTotal"
    :items-per-page="props.pageSize"
    :sibling-count="1"
    show-edges
  >
    <PaginationList v-slot="{ items }" class="PaginationList">
      <PaginationPrev :style="{ marginRight: 16 }" class="Button jump-button">Prev</PaginationPrev>
      <template v-for="(page, index) in items">
        <PaginationListItem
          class="Button"
          v-if="page.type === 'page'"
          :key="index"
          :class="{ selected: props.modelValue === page.value }"
          :value="page.value"
        >
          {{ page.value }}
        </PaginationListItem>
        <PaginationEllipsis v-else :key="page.type" :index="index" class="PaginationEllipsis">...</PaginationEllipsis>
      </template>
      <PaginationNext :style="{ marginLeft: 16 }" class="Button jump-button">Next</PaginationNext>
    </PaginationList>
  </PaginationRoot>
</template>

<script setup lang="ts">
  import { PaginationEllipsis, PaginationList, PaginationListItem, PaginationNext, PaginationPrev, PaginationRoot } from 'radix-vue';
  import { computed } from 'vue';

  defineEmits(['update:modelValue', 'change']);

  export interface Props {
    modelValue?: number;
    pageSize: number;
    totalItems?: number;
    totalPages?: number;
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: 1,
    totalItems: 0,
  });

  // Calculate total based on totalPages prop or totalItems/pageSize
  const calculatedTotal = computed(() => {
    if (props.totalPages) {
      return props.totalPages * props.pageSize;
    }
    return props.totalItems;
  });
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';

  .PaginationList {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .Button {
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;

    &[disabled] {
      cursor: not-allowed;
    }
  }

  .jump-button {
    background-color: $bg-dark;
  }

  .selected {
    background-color: $neutral-black;
    color: $white;
  }
</style>
